<template>
  <div id="add-requirement-container">
    <fixed-header :title="pageTitle" :listPage="'/requirements'" hideNewOfferBtn>
      <required-descriptor class="mb-0 mr-2" />
    </fixed-header>
    <div class="requirement--add-requirement">
      <div class="list-group-item">
        <form id="add-requirement">
          <section-header v-if="reqFields.REQUIREMENT_NUMBER > 0" :title="customerRFQ" />
          <div style="display: grid; grid-template-rows: repeat(1, 1fr); grid-template-columns: repeat(9, 1fr); grid-column-gap: 0.75rem; grid-row-gap: 0rem">
            <b-form-group label="Request Date" style="grid-column: 1; grid-row: 1;" class="mt-1 mr-2">
              <b-form-input
                v-if="requirementLine[reqFields.REQUIREMENT_ID]"
                :value="moment(header[reqFields.REQUIREMENT_DATE]).format(this.datePickerOptions.format)"
              />
              <date-picker
                v-model="header[reqFields.REQUIREMENT_DATE]"
                :config="datePickerOptions"
                :class="{ 'is-invalid': $v.header[reqFields.REQUIREMENT_DATE].$error }"
                v-if="!requirementLine[reqFields.REQUIREMENT_ID]"
              ></date-picker>
              <div class="invalid-feedback">
                <div v-if="!$v.header[reqFields.REQUIREMENT_DATE].required">Date is required</div>
              </div>
            </b-form-group>
            <b-form-group label="Customer RFQ #" style="grid-column: 2; grid-row: 1;" class="mt-1 mr-2">
              <b-form-input v-model="header[reqFields.REQUIREMENT_NUMBER]"></b-form-input>
            </b-form-group>

            <b-form-group  label="Customer" style="grid-column: 3/5; grid-row: 1;" class="mt-1 mr-2 required">
              <b-input-group size="sm">
                <b-input-group-append v-if="checkClaim(CAN_ADD_COMPANY) || checkClaim(CAN_EDIT_COMPANY)">
                  <b-button variant="light" @click="$refs.addNewCompany.showModal()">
                    <i v-if="checkClaim(CAN_ADD_COMPANY)" v-show="this.selectedAccount.id == undefined || this.selectedAccount.id == null || this.selectedAccount.id == 0" class="customer-lookup--plus fa fa-plus"></i>
                    <i v-if="checkClaim(CAN_EDIT_COMPANY)" v-show="this.selectedAccount.id > 0" class="customer-lookup--plus fa fa-pencil"></i>
                  </b-button>
                </b-input-group-append>
                <vue-simple-suggest
                  id="requirement-customer"
                  class="suggest-input form-control "
                  :class="{ 'is-invalid': this.customerNameTouched
                    && ($v.header[reqFields.COMPANY_ID].$required || !chosenName) }"
                  :styles="autoCompleteStyle"
                  :list="getListOfNames"
                  :max-suggestions="20"
                  :min-length="3"
                  :debounce="200"
                  v-model="chosenName"
                  :filter-by-query="true"
                  value-attribute="id"
                  display-attribute="name"
                  @select="onSuggestNameSelect"
                  @input="onSuggestNameChange"
                  @blur="onCompanyBlur"
                  @request-done="onRequestDone"
                  autocomplete="off"
                >
                <div slot="misc-item-below" v-if="isLoading" class="misc-item">
                  <span>Loading Customers...</span>
                </div>
                </vue-simple-suggest>
              </b-input-group>
                <div class="invalid-feedback">
                  <div v-if="!$v.header[reqFields.COMPANY_ID].required && !chosenName">Customer is required</div>
                </div>
            </b-form-group>

            <b-form-group label="Contact" style="grid-column: 5; grid-row: 1;" class="mt-1 mr-2 required">
              <b-input-group size="sm">
                <b-input-group-append v-show="selectedAccount.id > 0">
                  <b-button variant="light" @click="$refs.addNewContact.newContact()" >
                    <i class="customer-lookup--plus fa fa-plus"></i>
                  </b-button>
                </b-input-group-append>
                <b-form-select
                  v-model="header[reqFields.CONTACT_ID]"
                  :class="{ 'is-invalid': $v.header[reqFields.CONTACT_ID].$error }"
                  @blur="$v.header[reqFields.CONTACT_ID].$touch()"
                  @change="mergeHeader"
                  :disabled="!chosenName"
                >
                  <option
                    v-for="(select, index) in sortSelect(contacts,'firstName')"
                    :key="index"
                    :value="select.id"
                  >{{ select.firstName + ' ' + select.lastName }}</option>
                </b-form-select>
              </b-input-group>
              <div class="invalid-feedback">
                <div v-if="!$v.header[reqFields.CONTACT_ID].required">Contact is required</div>
              </div>
            </b-form-group>

            <b-form-group label="Referral Source" style="grid-column: 6; grid-row: 1;" class="mt-1 mr-2" >
              <lookup-dropdown
                label="source"
                moduleName="referralSources"
                resource="referralSource"
                propKey="referalSourceId"
                :value="header[reqFields.REFERAL_SOURCE_ID]"
                :options="referralSources"
                @change="onValueChange"
              />
            </b-form-group>

            <b-form-group label="Customer Note" style="grid-column: 7/9; grid-row: 1;" class="mt-1 mr-2">
              <b-form-input
                v-model="header[reqFields.CUSTOMER_NOTE]"
              ></b-form-input>
            </b-form-group>

            <b-form-group label="Sales Person" style="grid-column: 9; grid-row: 1;" class="mt-1 mr-2">
                <b-form-select v-model="header[reqFields.SALES_PERSON_USER_ID]">
                  <option
                    v-for="(selectRep, indexRep) in sortSelect(salesReps)"
                    :key="indexRep"
                    :value="selectRep.id"
                  >{{ selectRep.name }}</option>
                </b-form-select>
            </b-form-group>
          </div>
        </form>
      </div>
    </div>

    <requirement-details
      ref="requirementDetails"
      :crfqLineId="crfqLineId"
      :requirementId="requirementId"
      :showMOQ="false"
      @partChange="onPartChanged"
      @lineChange="onLineChanged"
      @headerChange="onHeaderChanged"
    />

    <div class="d-flex justify-content-between mt-2">
      <div></div>
      <div class="mr-3">
        <b-button size="sm" class="mr-2" @click="redirectToList">Exit</b-button>
        <b-button size="sm" class="mr-2" @click="clearPartDetails">Clear form</b-button>
        <b-button variant="primary" size="sm" class="mr-2" @click="onSave" :disabled="isSaving">
          <i v-if="isSaving" class="fa fa-spinner fa-pulse fa-fw mr-1"></i>Save</b-button>
        <b-button variant="primary" size="sm" class="mr-2" :disabled="isInvalidHeader || isInvalidLine || isSaving" @click="savePartAndNew">
          <i v-if="isSaving" class="fa fa-spinner fa-pulse fa-fw mr-1"></i>Save & New</b-button>
        <b-button variant="primary" size="sm" :disabled="isInvalidHeader || isInvalidLine || isSaving" @click="savePartAndFinish">
          <i v-if="isSaving" class="fa fa-spinner fa-pulse fa-fw mr-1"></i>Save & Finish</b-button>
      </div>
    </div>

    <edit-company
      ref="addNewCompany"
      hiddenButton
      :id="selectedAccount.id"
      :companyName="chosenName"
      @currentCompany="onCurrentCompany"
      @cancel="chosenName = ''"
    />

    <edit-contact
      :companyId="selectedAccount.id"
      ref="addNewContact"
      :inlineButton="true"
      :isQuickAdd="true"
      @created="onContactCreated"></edit-contact>
  </div>
</template>

<script>
/****************************************************************************************************
*****************************************************************************************************
*****************************************************************************************************
*****************************************************************************************************
*****************************************************************************************************
*****************************************************************************************************/

import { mapGetters, mapState, mapActions } from 'vuex';
import VueSimpleSuggest from 'vue-simple-suggest';
import { required } from 'vuelidate/lib/validators';
import EditContact from '@/pages/Company/components/CompanyDetails/tabs/Contacts/components/EditContact/index';
import moment from 'moment';

import {
  DATE_FORMAT,
  AUTO_COMPLETE_STYLES,
  LEAD_FREE_VALUES,
  US_DOLLARS_CURRENCY_ID,
  CUSTOMER_ID
} from '@/shared/constants';
//import { FIELDS as INVENTORY_FIELDS } from '@/pages/Inventory/components/InventoryDetails/constants';
//import { CRFQ_PART_STATUSES } from '@/pages/Requirements/constants';

import FixedHeader from '@/shared/components/FixedHeader/indexNew';
import RequirementDetails from '@/shared/components/RequirementDetails/index';

import { FIELDS as REQUIREMENT_FIELDS } from '../../../../constants';
import FormElWrap from '@/shared/components/FormElWrap/index';
import EditCompany from '@/pages/Company/components/EditCompany';

export default {
  props: {
    pageTitle: {
      type: String,
      default: ""
    },
  },
  components: {
    VueSimpleSuggest,
    FixedHeader,
    RequirementDetails,
    EditCompany,
    EditContact,
    FormElWrap
  },
  data() {
    return {
      reqFields: REQUIREMENT_FIELDS,
      autoCompleteStyle: AUTO_COMPLETE_STYLES,
      //invFields: INVENTORY_FIELDS,
      datePickerOptions: {
        format: DATE_FORMAT,
        useCurrent: false,
      },
      customerNameTouched: '',
      chosenName: '',
      contactFirstNameTouched: false,
      contactLastNameTouched: false,
      newContact: {},
      selectedAccount: {},
      header: {},
      mergedRequirementLinesObj: {},
      requirementLine: {},
      isInvalidLine: true,
      headerRequired: [
        REQUIREMENT_FIELDS.COMPANY_ID,
        REQUIREMENT_FIELDS.CONTACT_ID,
      ],
      lineRequired: [
        REQUIREMENT_FIELDS.PART_ID,
        REQUIREMENT_FIELDS.QUANTITY,
        REQUIREMENT_FIELDS.PRICE
      ],
      salesPersonId: null,
      isLoading: false,
      isSaving:false,
      companiesList: []
    };
  },
  validations: {
    header: {
      [REQUIREMENT_FIELDS.COMPANY_ID]: { required },
      [REQUIREMENT_FIELDS.CONTACT_ID]: {},
      [REQUIREMENT_FIELDS.REQUIREMENT_DATE]: { required },
    },
  },
  computed: {
    ...mapState('requirementAdd', [
      'requirementHeader',
    ]),
    ...mapState('salesReps', ['salesReps']),
    ...mapGetters('requirementAdd', [
      'contacts',
      'customers',
      'currentRequirementLine',
    ]),
    ...mapGetters('lookup', ['referralSources']),
    ...mapGetters('companies', ['companyById']),
    ...mapGetters('account', ['isSalesRep', 'userId']),
    requirementId() {
      return this.$route.query.crfqId;
    },
    customerRFQ() {
      return ('Customer RFQ ' + this.header[this.reqFields.REQUIREMENT_NUMBER]);
    },
    crfqLineId() {
      return this.$route.query.crfqLineId;
    },
    customerId() {
      return this.$route.query.customer;
    },
    contactId() {
      return this.$route.query.contact;
    },
    isInvalidHeader() {
      let disablesSave = false;

      return disablesSave;
    }
  },
  watch: {
    header: {
      handler() {
        if (this.requirementId) {
          this.mergedRequirementLinesObj.requirement = {
            ...this.mergedRequirementLinesObj.requirement,
            ...this.header,
          };
        } else {
          this.mergeHeader();
        }
      },
      deep: true,
    },
  },
  methods: {
    ...mapActions('companies', {
      getCompanyById: 'getById',
    }),
    ...mapActions('companies', [
      'getCustomerPartNumber',
      'getByNameAndAccountType'
    ]),
    ...mapActions('requirementAdd', [
      'getRequirementLines',
      'addRequirement',
      /*'addRequirementLine',
      'updateRequirementLine',*/
      'getCustomers',
      'getContacts',
      'clearContacts',
      'manageRequirementLine',
    ]),
    // ...mapActions('requirements', ['showDetails']),
    ...mapActions('salesReps', ['getSalesReps']),
    isValidValue(elem) {
      let res = elem != undefined && elem != null && elem != "" && elem > 0;
      return res;
    },
    validateLines() { // Not included in computed due to the separated form component
      this.isInvalidLine = false;

      // if(this.mergedRequirementLinesObj.lines === undefined)
      // {
      //   //debugger;
      //   //we have a single object
      //   for (let i = 0; i<this.lineRequired.length; i++)  { // For Lines
      //     let elem = this.lineRequired[i];
      //       if (!this.isValidValue(this.mergedRequirementLinesObj[elem])) {
      //         this.isInvalidLine = true;
      //         break;
      //       }
      //   }
      // }
      // else{
      //   debugger;
      //   //we have an array of lines
      //   let linesArr = this.mergedRequirementLinesObj.lines;
      //   for (let i = 0; i<this.lineRequired.length; i++)  { // For Lines
      //     let elem = this.lineRequired[i];
      //     for (let k = 0; k < linesArr.length; k++) {
      //       if (!this.isValidValue(linesArr[k][elem])) {
      //         this.isInvalidLine = true;
      //         break;
      //       }
      //     }
      //   }
      // }

    },
    mergeHeader() {
      this.mergedRequirementLinesObj = {
        ...this.mergedRequirementLinesObj,
        ...this.header
      }
    },
    async onCurrentCompany(val) {
      this.setSelectedAccount(val.id, val.name);
      this.header[REQUIREMENT_FIELDS.COMPANY_ID] = val.id;
      this.chosenName = val.name;
      await this.getContacts(val.id).then(() => {
        if (this.contacts.length > 0){
          console.log('Setting the value...')
          this.header[REQUIREMENT_FIELDS.CONTACT_ID] = this.contacts[0].id;
          this.$v.header[REQUIREMENT_FIELDS.CONTACT_ID].$touch();
        }

      });
      this.mergeHeader();
    },
    async getListOfNames(name) {
      this.companiesList = await this.getByNameAndAccountType({
        typeId: CUSTOMER_ID, name});
      return this.companiesList;
    },
    async onContactCreated(id) {
      await this.getContacts(this.header.companyId);
      this.header[REQUIREMENT_FIELDS.CONTACT_ID] = id;
    },
    async onSuggestNameSelect(suggestion) {
      console.log(suggestion, "Suggestion")
      this.setSelectedAccount(suggestion.id, suggestion.name);
      this.header[REQUIREMENT_FIELDS.COMPANY_ID] = suggestion.id;
      this.mergeHeader();
      this.newContact = {};
      await this.getContacts(suggestion.id);

      // If customer and existing part selected
      if(this.header.companyId && this.mergedRequirementLinesObj.partId) {
        await this.getCustomerPartNumber({
          companyId: this.header.companyId,
          partId: this.mergedRequirementLinesObj.partId,
        });
      }
    },
    setSelectedAccount(id, name) {
      this.selectedAccount = {
        id: id,
        name: name
      }
    },
    async onSuggestNameChange() {
      this.isLoading = true;
      if (this.selectedAccount.name && this.chosenName !== this.selectedAccount.name) {
        this.selectedAccount = { id: 0 }
        this.header[REQUIREMENT_FIELDS.COMPANY_ID] = null;
        this.header[REQUIREMENT_FIELDS.CONTACT_ID] = null;
        this.$v.header[REQUIREMENT_FIELDS.COMPANY_ID].$touch();
        await this.clearContacts();
      }
    },
    async onCompanyBlur() {
      this.customerNameTouched = true;
      if(this.chosenName) {
        if (this.companiesList.length > 0) {
          const findIndex = this.companiesList.findIndex(x => this.chosenName.toLowerCase() == x.name.toLowerCase());

          if (findIndex > -1) {
            this.onSuggestNameSelect(this.companiesList[findIndex]);
          } else {
            this.companyNotFoundConfirmation();
          }
        } else {
          this.companyNotFoundConfirmation();
        }
      }
    },
    async companyNotFoundConfirmation() {
      const deleteConfirmed = await this.openConfirmBox({okTitle: 'Continue',message: `${this.chosenName} is not in the database. Press Continue to add them.`});
      if (deleteConfirmed) {
        this.selectedAccount = {};
        this.header[REQUIREMENT_FIELDS.COMPANY_ID] = null;
        this.header[REQUIREMENT_FIELDS.CONTACT_ID] = null;
        this.$refs.addNewCompany.showModal();
      } else {
        this.chosenName = "";
      }
    },
    onRequestDone() {
      this.isLoading = false;
    },
    async onFirstNameBlur() {
      this.contactFirstNameTouched = true;
    },
    async onLastNameBlur() {
      this.contactLastNameTouched = true;
    },
    onValueChange({ name, value }) {
      console.log(name, value, 'Hey')
      this.header = {
        ...this.header,
        [name]: value
      };
    },
    onPartChanged(part) {
      if (this.requirementId) {
        this.mergedRequirementLinesObj.part = part;
      } else {
        if (this.mergedRequirementLinesObj.lines[0] != undefined) {
          this.mergedRequirementLinesObj.lines[0].part = part;
          this.mergedRequirementLinesObj.lines[0].partId = part.id;
        }
      }
    },
    onLineChanged(line) {
      console.log(line, 'Line Changed');

      if (this.requirementId) {
        this.mergedRequirementLinesObj = {
          ...this.mergedRequirementLinesObj,
          ...line,
        };
      } else {
        this.mergedRequirementLinesObj.lines[0] = {
          ...this.mergedRequirementLinesObj.lines[0],
          ...line,
        };
      }
      this.validateLines();
    },
    onHeaderChanged(header) {
      console.log(header, 'Header Changed');

      if (this.requirementId) {
        this.mergedRequirementLinesObj.requirement.currencyTypeId =
          header.currencyTypeId;
        this.mergedRequirementLinesObj.requirement.exchangeRate =
          header.exchangeRate;
      } else {
        this.mergedRequirementLinesObj.currencyTypeId = header.currencyTypeId;
        this.mergedRequirementLinesObj.exchangeRate = header.exchangeRate;
      }
    },
    redirectToList() {
      this.$router.push({
        name: 'requirements',
      });
    },
    async clearPartDetails() {
      if (this.requirementId && this.crfqLineId) {
        //Requirement and line already exists
        await this.getRequirementLines(this.requirementId);
      } else {
        if(this.customerId) {
          this.header = {
            companyId: this.header.companyId,
            requirementDate: moment(new Date()).format(this.datePickerOptions.format)
          };
        } else {
          this.header = { requirementDate: moment(new Date()).format(this.datePickerOptions.format) };
        }

        //Prevent clearing customer name if clicked on from companies
        if(!this.customerId) this.chosenName = '';

        this.$refs.requirementDetails.clearForm();
      }
      // await this.clearCurrentPart();

      // this.part = { id: 0, classId: 0, conditionId: 0, packageId: 0 };
      // this.chosenPartNumber = '';
      // this.$v.chosenPartNumber.$reset();
    },
    validateForm() {
      console.log('validate form')
      this.$snotify.info('Processing Requirements', 'Requirements');
      const h = this.$createElement
      let isValid = false;
      let errors = [];
      //alert('companyId: ' + this.$v.header[REQUIREMENT_FIELDS.COMPANY_ID].required + ' - ' + this.header[REQUIREMENT_FIELDS.COMPANY_ID]);

      if(this.header[REQUIREMENT_FIELDS.COMPANY_ID] == undefined || this.header[REQUIREMENT_FIELDS.COMPANY_ID] == null || !this.header[REQUIREMENT_FIELDS.COMPANY_ID]){
        errors.push( h('li', {}, 'You must select or create a customer'));
      }

      if(this.header[REQUIREMENT_FIELDS.CONTACT_ID] == undefined || this.header[REQUIREMENT_FIELDS.CONTACT_ID] == null || !this.header[REQUIREMENT_FIELDS.CONTACT_ID]){
        errors.push( h('li', {}, 'You must select a contact'));
      }

      if(this.mergedRequirementLinesObj.lines == undefined){
        if(!this.isValidValue(this.mergedRequirementLinesObj[REQUIREMENT_FIELDS.PART_ID]) || (this.mergedRequirementLinesObj[REQUIREMENT_FIELDS.PART_ID] == undefined || this.mergedRequirementLinesObj[REQUIREMENT_FIELDS.PART_ID] == null || this.mergedRequirementLinesObj[REQUIREMENT_FIELDS.PART_NUMBER] == '') ){
          errors.push( h('li', {}, 'You must select or create a part'));
        }
        if(!this.isValidValue(this.mergedRequirementLinesObj[REQUIREMENT_FIELDS.QUANTITY])){
          errors.push( h('li', {}, 'You must enter a quantity'));
        }
        if(!this.isValidValue(this.mergedRequirementLinesObj[REQUIREMENT_FIELDS.PRICE])){
          errors.push( h('li', {}, 'You must enter a price'));
        }

      }
      else{
        //alert('mergedRequirementLinesObj has multiple lines');
        this.mergedRequirementLinesObj.lines.forEach(element => {
          if( (
            element[REQUIREMENT_FIELDS.PART_ID] == undefined ||
            element[REQUIREMENT_FIELDS.PART_ID] == null ||
            element[REQUIREMENT_FIELDS.PART_ID] == '') ){
          errors.push( h('li', {}, 'You must select or create a part'));
        }
        if(!this.isValidValue(element[REQUIREMENT_FIELDS.QUANTITY])){
          errors.push( h('li', {}, 'You must enter a quantity'));
        }
        if(!this.isValidValue(element[REQUIREMENT_FIELDS.PRICE])){
          errors.push( h('li', {}, 'You must enter a price'));
        }
        });
      }

      let validationMsg = h('ul', {}, errors);

      if(isValid = errors.length > 0){
        this.openAlertBox({message: validationMsg,title: 'Please correct the following'});
      }

      return !isValid;

    },
    async savePart() {
      if (this.requirementId && !this.crfqLineId) { //Requirement exist
        /*return await this.addRequirementLine(this.mergedRequirementLinesObj);*/
        this.mergedRequirementLinesObj.requirementId = this.requirementId;
        return await this.manageRequirementLine(this.mergedRequirementLinesObj);
      } else if (this.requirementId && this.crfqLineId) { //Requirement and line already exists
        this.mergedRequirementLinesObj.requirementId = this.requirementId;
        this.mergedRequirementLinesObj.id = this.crfqLineId;
        /*return await this.updateRequirementLine(this.mergedRequirementLinesObj);*/
        return await this.manageRequirementLine(this.mergedRequirementLinesObj);
      } else { //New Requirement and line
        return await this.addRequirement(this.mergedRequirementLinesObj);
      }
    },
    async savePartAndNew() {

      if(this.validateForm()){
        try {
          this.isSaving = true;
          const requirement = await this.savePart();
          this.isSaving = false;

          if (this.requirementId && this.crfqLineId) requirement.id = requirement.requirementId;

          const requirementId = this.requirementId ? this.requirementId : requirement.id;

          if (!this.crfqLineId) {
            // Only do this with no line, to prevent unecessary AJAX call
            await this.getRequirementLines(requirementId);
          }

          this.$refs.requirementDetails.clearForm();

          this.$snotify.success('Requirements Saved', 'Requirements');

          this.$router.push({
            name: 'requirements.crfq',
            query: {crfqId: requirementId},
          });
          // this.partAdded = false;
          // await this.savePart();
          // if (this.partAdded) {
          //   this.clearPartDetails();

          //   this.$router.push({
          //     name: 'requirements.add.crfq-parts',
          //     params: { crfqId: this.header.id },
          //   });
          // }
        }catch (e) {
          this.isSaving = false;
        }
      }
    },
    async savePartAndFinish() {

      if(this.validateForm()){
        try{
          this.isSaving = true;
          await this.savePart();
          this.isSaving = false;
          this.$snotify.success('Requirements Saved', 'Requirements');

          this.$router.push({
            name: 'requirements',
          });
          // this.partAdded = false;
          // await this.savePart();
          // if (this.partAdded) {
          //   this.$router.push({
          //     name: 'requirements.list.sources',
          //   });
          // }
        }catch (e) {
          this.isSaving = false;
          /*console.log(e.message);*/
        }
      }
    },

    async onSave() {
      if (this.validateForm()) {
        try {
          this.isSaving = true;
          const requirement = await this.savePart();
          this.isSaving = false;
          this.$snotify.success('Requirements Saved', 'Requirements');

          if (!this.requirementId && !this.crfqLineId
            && requirement.id != undefined && requirement.lines.length
          ) {
            this.$router.push({
              name: 'requirements.crfq',
              query: {crfqId: requirement.id, crfqLineId: requirement.lines[0].id, partId: requirement.lines[0].partId},
            });
          }
        }catch (e) {
          this.isSaving = false;
          /*console.log(e.message);*/
        }
      }
    }
  },
  async created() {
    if(this.requirementId) {
      this.mergedRequirementLinesObj.requirement = {};
      this.setContainerLoader(true);
      await this.getRequirementLines(this.requirementId).then(async () => {
        this.setContainerLoader(false);
        await this.getSalesReps();

        this.requirementLine = this.crfqLineId ? this.currentRequirementLine(this.crfqLineId) : this.requirementHeader;

        this.chosenName = this.requirementLine[this.reqFields.COMPANY_NAME];

        this.header = {
          id: this.requirementId,
          companyId: this.requirementLine[this.reqFields.COMPANY_ID],
          contactId: this.requirementLine[this.reqFields.CONTACT_ID],
          requirementDate: moment(this.requirementLine[this.reqFields.REQUIREMENT_DATE]).format(this.datePickerOptions.format),
          requirementNumber: this.requirementLine[
            this.reqFields.REQUIREMENT_NUMBER
            ],
          referalSourceId: this.requirementLine[this.reqFields.REFERAL_SOURCE_ID],
          customerNote: this.requirementLine[this.reqFields.CUSTOMER_NOTE],
          salesPersonUserId: (this.requirementLine[this.reqFields.SALES_PERSON_USER_ID])
            ? this.requirementLine[this.reqFields.SALES_PERSON_USER_ID] : (this.isSalesRep) ? this.userId : 0,
          active: this.requirementLine[this.reqFields.ACTIVE],
        };

        this.setSelectedAccount(this.requirementLine[this.reqFields.COMPANY_ID], this.requirementLine[this.reqFields.CONTACT_ID]);

        console.log(this.header.requirementDate);

        await this.getContacts(this.header.companyId);
      }).catch(() => {
        this.setContainerLoader(false);
        //return back to listing page because error in fetch record
        this.$router.push({name: 'requirements'});
      });;

    } else {
      this.mergedRequirementLinesObj = {
        lines: [],
        id: 0,
      };

      if(this.customerId) {
        let companyObj = this.companyById(this.customerId);

        if(Object.keys(companyObj).length === 0 && companyObj.constructor === Object) {
          await this.getCompanyById(this.customerId);

          companyObj = this.companyById(this.customerId);
        }

        this.chosenName = companyObj.name;

        this.header = { ...this.header, companyId: this.customerId };
        this.setSelectedAccount(this.customerId, this.chosenName);
        await this.getContacts(this.customerId).then(() => {
          if (this.contactId && this.contacts.findIndex(x => x.id == this.contactId) !== -1) {
            this.header = { ...this.header, contactId: this.contactId };
          }
        });
      }

      this.header = {
        ...this.header,
        requirementDate: moment(new Date()).format(this.datePickerOptions.format),
        salesPersonUserId: (this.isSalesRep) ? this.userId : 0,
      };
    }
  },
};
</script>

<style lang="scss">
// #add-requirement-container .form-input, #add-requirement-container .custom-select { //Default width
//   width: 150px;
// }

#requirement-request-date {
  width: 150px;
}

.requirement-long-input {
  width: 300px;
}

#requirement-customer-note {
  width: 650px;
}

@import '@/assets/scss/_colors.scss';

.requirement--add-requirement {
  .inline-header {
    margin-bottom: 10px;
    padding-bottom: 5px;
    border-bottom: 1px solid $dirtyWhite;
    color: $mutedGray;
    font-weight: bold;

    &.margin-top {
      margin-top: 20px;
    }
  }

  .buttons-panel {
    margin-top: 20px;
    text-align: right;

    .btn {
      margin-left: 10px;
    }
  }

  .form-control.is-invalid {
    padding-right: 0px;
  }

  .last-name-input {
    margin-top: 5px;
  }

  .vue-simple-suggest.designed {
    .input-wrapper {
      input {
        height: 27px;
        background: transparent;
        padding-right: 30px;
      }
    }
  }
}

.requirement--add--part {
  .inline-header {
    margin-bottom: 10px;
    padding-bottom: 5px;
    border-bottom: 1px solid $dirtyWhite;
    color: $mutedGray;
    font-weight: bold;

    &.margin-top {
      margin-top: 20px;
    }
  }

  .buttons-panel {
    margin-top: 10px;
    text-align: right;

    .btn {
      margin-left: 10px;
    }
  }

  .form-control.is-invalid {
    padding-right: 0px;
  }

  .vue-simple-suggest.designed {
    .input-wrapper {
      input {
        height: 27px;
        background: transparent;
        padding-right: 30px;
      }
    }
  }

  .customer-lookup {
    &--plus {
      font-size: 8px;
    }
  }
}
</style>
